import React, { ReactNode, useContext, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import DocumentService from 'services/document';
import { FileData } from 'API';
import { DICTIONARY } from 'shared/constants';
import AlertContext from 'shared/contexts/AlertContext';

const StyledButton = styled('button')({
  background: 'none',
  border: 'none',
  color: 'inherit',
  display: 'inline-block',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  outline: 'none',
  padding: 0,
  '&:hover': {
    cursor: 'pointer',
  },
});

interface Props {
  className?: string;
  file?: FileData;
  children: ReactNode;
}

const InlineDownloadButton: React.FC<Props> = (
  { children, className, file }: Props,
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [, setAlert] = useContext(AlertContext);

  const downloadHandler = async () => {
    setIsLoading(true);

    try {
      await DocumentService.downloadDocument(file!);
    } catch {
      setAlert([DICTIONARY.DownloadError, 'error']);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {file?.original ? (
        <StyledButton
          className={className}
          onClick={downloadHandler}
          type="button"
        >
          {isLoading && (
            <>
              <CircularProgress size="1em" />
              {' '}
            </>
          )}
          {children}
        </StyledButton>
      ) : children}
    </>
  );
};

export default InlineDownloadButton;
